import { STATE_PAGE, MESSAGE } from './actions';

const INIT_STATE = {
  dataStates: {},
  message: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case STATE_PAGE:
      return {
        ...state,
        dataStates: {
          ...state.dataStates,
          [action.payload.statusKey]: {
            ...state.dataStates[action.payload.statusKey],
            ...action.payload.values,
          },
        },
      };
    case MESSAGE:
      return {
        ...state,
        message: action.payload,
      };
    default:
      return state;
  }
};
